import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { validateEmail } from "../../helpers/validationEmail"
import { CloseEyePassword, OpenEyePassword } from "../Icons/Icons"
import { LuSearch } from "react-icons/lu"

const Input = ({
  parentClassName,
  width = 65,
  disabled,
  errorMsg,
  classes,
  placeholder,
  label,
  type,
  setInput,
  onChange,
  onKeyDown,
  name,
  max,
  min,
  step,
  pattern,
  readOnly,
  maxLength,
  minLength,
  value,
  autoFocus,
  autoComplete,
  required,
  rightSideIcon,
  rightSideIconStyle,
  leftSideIconStyle,
  leftSideIcon,
  inputRef,
}) => {
  width = width || 'w-full'

  const [focus, setFocus] = useState(false)
  const [passwordVisible, setPasswordVisible] = useState(false)

  const createStylesByType = () => {
    const placeholderStyle = errorMsg ? `placeholder:text-primary-static-error-400` : `placeholder:text-text-secondary`
    // py-4 + text-lg made inputs 62px while Dropdown and Calendar sit at 56px, so
    // neighbouring fields in the same grid row never lined up. 56px everywhere.
    const defaultStyles = `h-14 px-3.5 bg-transparent text-text-primary text-md font-normal rounded-lg focus:outline-none border ${placeholderStyle}`
    const hovered = 'enabled:hover:border-text-primary'
    const focused = 'focus:border-text-primary focus-within:text-text-primary '
    const disabledStyles = 'disabled:hover:border-divider'
    const incorrect = 'border-primary-static-error-600 hover:border-primary-static-error-600'

    if (errorMsg) {
      return `${defaultStyles} ${incorrect}`
    } else {
      return `${defaultStyles} border-divider ${hovered} ${disabledStyles} ${focused} ${(type === 'search' || leftSideIcon) ? 'pl-[44px]' : ''}`
    }
  }

  const getLabelStyle = () => {
    const labelStyle = `flex justify-start flex-col`

    if (disabled) return `${labelStyle} text-text-secondary`
    if (errorMsg) return `${labelStyle} text-primary-static-error-600`
    if (focus) return `${labelStyle} text-text-primary`
    else return `${labelStyle} text-text-secondary`
  }

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible)
  }
  if (type === "email") {
    if (!validateEmail(value) && !focus && value?.length !== 0) errorMsg = "Email is incorrect"
  }
  if (type === "phone-number") {
    if (value?.length !== 14 && !focus && value?.length !== 0) errorMsg = "Phone number is incorrect"
  }
  return (
    <div className={parentClassName}>
      <label className={getLabelStyle()}>
        {label && <span className={`mb-2 text-[13px] leading-5 text-start max-w-max`}>{label}</span>}
        <div className="relative">
          {type === 'search' && (
            <LuSearch
              size={18}
              className="absolute left-3.5 top-1/2 -translate-y-1/2 text-text-secondary pointer-events-none"
            />
          )}
          {<span
            className={`material-icons-outlined absolute left-0 top-0 ${leftSideIconStyle}`}
          >
            {leftSideIcon}
          </span>}
          <input
            className={classnames(createStylesByType(), classes, width)}
            placeholder={placeholder}
            name={name}
            disabled={disabled}
            type={type === 'password' ? (passwordVisible ? 'text' : 'password') : type === "search" ? "" : type}
            onInput={(e) => (setInput ? setInput(e.target.value) : null)}
            onChange={onChange}
            onKeyDown={onKeyDown}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            max={max}
            min={min}
            step={step}
            pattern={pattern}
            maxLength={maxLength}
            minLength={minLength}
            readOnly={readOnly}
            value={value}
            autoFocus={autoFocus}
            autoComplete={autoComplete}
            required={required}
            ref={inputRef}
          />
          {type === 'password' && (
            <span
              className="material-icons-outlined text-text-secondary absolute right-0 top-0 mt-4 mr-4 cursor-pointer"
              onClick={togglePasswordVisibility}
            >
              {passwordVisible ? <OpenEyePassword /> :
                <CloseEyePassword />}
            </span>
          )}
          {<span
            className={`absolute right-0 top-0 ${rightSideIconStyle}`}
          >
            {rightSideIcon}
          </span>}
        </div>
        <span className="ml-4 text-sm mt-0.25 w-full text-start">
          {typeof errorMsg === 'string' ? errorMsg : ''}
        </span>
      </label>
    </div>
  )
}

Input.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  width: PropTypes.string,
  errorMsg: PropTypes.string,
  classes: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
}

Input.defaultProps = {
  label: '',
  disabled: false,
  fontSize: '',
  width: '',
  errorMsg: '',
  classes: '',
}

export default Input
